import { render, staticRenderFns } from "./Coaching_IND.vue?vue&type=template&id=27cb2c4a"
import script from "./Coaching_IND.vue?vue&type=script&lang=js"
export * from "./Coaching_IND.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports